import Component from '../../common/Component';
import listItems from '../../common/helpers/listItems';
import UserCard from './UserCard';
import ComposerPostPreview from './ComposerPostPreview';
import app from '../app';
import escapeRegExp from '../../common/utils/escapeRegExp';
import highlight from '../../common/helpers/highlight';
export default class Comment extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view() {
    let contentHtml = this.attrs.isEditing ? '' : this.attrs.contentHtml;
    if (!this.attrs.isEditing && this.attrs.search) {
      const phrase = escapeRegExp(this.attrs.search);
      const highlightRegExp = new RegExp(phrase + '|' + phrase.trim().replace(/\s+/g, '|'), 'gi');
      contentHtml = highlight(contentHtml, highlightRegExp, undefined, true);
    } else {
      contentHtml = m.trust(contentHtml);
    }
    return [m("header", {
      className: "Post-header"
    }, m("ul", null, listItems(this.attrs.headerItems.toArray())), !this.attrs.isHidden && this.attrs.cardVisible && this.attrs.user && m(UserCard, {
      user: this.attrs.user,
      className: "UserCard--popover",
      controlsButtonClassName: "Button Button--icon Button--flat"
    })), m("div", {
      className: "Post-body"
    }, this.attrs.isEditing ? m(ComposerPostPreview, {
      className: "Post-preview",
      composer: app.composer
    }) : contentHtml)];
  }
}
flarum.reg.add('core', 'forum/components/Comment', Comment);